import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49773a8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products-services-block-content-wrap" }
const _hoisted_2 = { class: "products-services-block" }
const _hoisted_3 = { class: "products-services-block-header-title-block margin-l" }
const _hoisted_4 = { class: "products-services-block-header-text" }
const _hoisted_5 = { class: "products-services-block-text-wrap" }
const _hoisted_6 = { class: "products-services-block-text" }

import {comprehensive, useLocalizationStore} from "@/shared";
import {BlockPreviewData, WrapTitle} from "@/entities";
import {ExploreNow} from "@/features";
import UiButton from "@/shared/ui/ui-button/ui-button.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'products-services-block',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BlockPreviewData), {
        "body-title": _unref(translate)('unlock_business'),
        image: _unref(comprehensive),
        class: "products-services-block-preview-data"
      }, {
        "header-title": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(WrapTitle), {
              text: _unref(translate)('comprehensive_fintech'),
              class: "products-services-block-header-title",
              weight: "700",
              size: "regular"
            }, null, 8, ["text"]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)("secure_and_innovative")), 1)
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, _toDisplayString(_unref(translate)("offer_range")), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(translate)("we_also_offer")), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["body-title", "image"]),
      _createVNode(_unref(ExploreNow), { class: "explore-now-preview-data" })
    ])
  ]))
}
}

})